// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    FolderMinus,
    FolderOpen,
    FolderOpenDot,
    FolderOutput,
    FolderPen,
    FolderPlus,
    FolderRoot,
    FolderSearch,
    FolderSearch2,
    FolderSymlink,
    FolderSync,
    FolderTree,
    FolderUp,
    FolderX,
    Folders,
    Footprints,
    Forklift,
    Form,
    Forward,
    Frame,
    Fuel,
    Fullscreen,
    Funnel,
    FunnelPlus,
    FunnelX,
    Galaxy,
    GalleryHorizontal,
    GalleryHorizontalEnd,
    GalleryThumbnails,
    GalleryVertical,
    GalleryVerticalEnd,
    Gamepad,
    Gamepad2,
    GamepadDirectional,
    Gauge,
    Gavel,
    Gem,
    GeorgianLari,
    Germ,
    GermOff,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "folder-minus" through "germ-off", inclusive. */
const shard: Record<string, LucideIcon> = {
    "folder-minus": FolderMinus,
    "folder-open": FolderOpen,
    "folder-open-dot": FolderOpenDot,
    "folder-output": FolderOutput,
    "folder-pen": FolderPen,
    "folder-plus": FolderPlus,
    "folder-root": FolderRoot,
    "folder-search": FolderSearch,
    "folder-search-2": FolderSearch2,
    "folder-symlink": FolderSymlink,
    "folder-sync": FolderSync,
    "folder-tree": FolderTree,
    "folder-up": FolderUp,
    "folder-x": FolderX,
    folders: Folders,
    footprints: Footprints,
    forklift: Forklift,
    form: Form,
    forward: Forward,
    frame: Frame,
    fuel: Fuel,
    fullscreen: Fullscreen,
    funnel: Funnel,
    "funnel-plus": FunnelPlus,
    "funnel-x": FunnelX,
    galaxy: Galaxy,
    "gallery-horizontal": GalleryHorizontal,
    "gallery-horizontal-end": GalleryHorizontalEnd,
    "gallery-thumbnails": GalleryThumbnails,
    "gallery-vertical": GalleryVertical,
    "gallery-vertical-end": GalleryVerticalEnd,
    gamepad: Gamepad,
    "gamepad-2": Gamepad2,
    "gamepad-directional": GamepadDirectional,
    gauge: Gauge,
    gavel: Gavel,
    gem: Gem,
    "georgian-lari": GeorgianLari,
    germ: Germ,
    "germ-off": GermOff,
};

export default shard;
